export let EndpointKey;

(function (EndpointKey) {
  EndpointKey["InitiateVerification"] = "InitiateVerification";
  EndpointKey["CompleteVerification"] = "CompleteVerification";
  EndpointKey["CompleteVerificationByCode"] = "CompleteVerificationByCode";
  EndpointKey["Signup"] = "Signup";
  EndpointKey["CompanyInfo"] = "CompanyInfo";
  EndpointKey["VistorContextFetch"] = "VistorContextFetch";
  EndpointKey["SubmitSurveyAuthenticated"] = "SubmitSurveyAuthenticated";
  EndpointKey["BulkExperimentRequest"] = "BulkExperimentRequest";
  EndpointKey["TrackSignupCompleted"] = "TrackSignupCompleted";
  EndpointKey["TrackSurveyCompleted"] = "TrackSurveyCompleted";
  EndpointKey["LoginNewPortal"] = "LoginNewPortal";
  EndpointKey["AcademyContentPageName"] = "AcademyContentPageName";
  EndpointKey["GetRecommendedHublet"] = "GetRecommendedHublet";
  EndpointKey["WordpressAuthorization"] = "WordpressAuthorization";
  EndpointKey["PartnerLookup"] = "PartnerLookup";
  EndpointKey["ValidateOAuthPermissions"] = "ValidateOAuthPermissions";
  EndpointKey["PartnerRegistrationLeadLookup"] = "PartnerRegistrationLeadLookup";
  EndpointKey["GateLookup"] = "GateLookup";
  EndpointKey["LoginWordpressPortal"] = "LoginWordpressPortal";
  EndpointKey["PostSignup"] = "PostSignup";
  EndpointKey["InitialInterest"] = "InitialInterest";
})(EndpointKey || (EndpointKey = {}));

export const isValidEndpointKey = endpointKey => {
  return Object.keys(EndpointKey).includes(endpointKey);
};